import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';

class DepartmentsDepartmentSettingsRoute extends Route {
  model() {
    return this.modelFor('departments.department');
  }
}

export default instrumentRoutePerformance(DepartmentsDepartmentSettingsRoute);
